import React from 'react';
import {RootState} from "../../../../../../../reducers";
import {getItems, getModifierGroups, getPromotions} from "../../../../../../services/Menu/reducer";
import {getCart} from "../../../../../../services/Cart/reducer";
import {getSession} from "../../../../../../services/Session/reducer";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import StateItemHelper from "../../../../../../services/Menu/services/State/StateItemHelper";
import PromotionHelper from "../../../../../../services/Menu/services/Promotion/PromotionHelper";
import {createKeyDownHandler} from "../../../../../../utils/keyDownHanlder";
import Money from "../../../../../../components/Common/Money";
import {ReactComponent as CheckCircleIco} from "../../../../../../../images/icons/check-circle.svg";
import MenuEditItemViewHelper from "../../../../../../services/Menu/services/ItemView/MenuEditItemViewHelper";

interface OwnProps {
    session: Record<string, any>;
    cart: Record<string, any>;
    productState: Record<string, any>;
    variant: { item: Record<string, any>; itemInfo: Record<string, any>; itemView: Record<string, any> };
    productItemGroup: Record<string, any>;
    updateProductState: (productState: Record<string, any>) => void;
    priceDisplayMode: "mixed" | "allPaid" | "allFree";
    isProductAvailable: boolean;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const ProductVariant = ({
                            items,
                            cart,
                            session,
                            productState,
                            variant,
                            productItemGroup,
                            modifierGroups,
                            promotions,
                            updateProductState,
                            priceDisplayMode,
                            isProductAvailable
                        }: Props) => {
    const {
        itemInfo,
        itemView,
        item
    } = variant;
    const itemPrice = itemInfo.price ? itemInfo.price : {amount: 0};
    const disabled = !isProductAvailable || itemView.disabled;
    const checked = productState.item_id === item.item_id;

    const handleChange = () => {
        if (disabled) return;

        const newItemState = StateItemHelper.create(item.item_id, items, modifierGroups, session.order_type);
        StateItemHelper.refreshItemPrice(newItemState, PromotionHelper.getForItem(promotions, productState.item_id), cart);
        updateProductState(newItemState)
    }

    const handleOnKeyDown = () => createKeyDownHandler<HTMLDivElement>({
        keys: ["Enter", " "],
        preventDefault: true,
        action: () => handleChange()
    });

    const renderPrice = () => {
        if (priceDisplayMode === "allFree") return <></>;

        const moneyComponent = <Money value={itemPrice}/>;

        if (priceDisplayMode === "allPaid") {
            return moneyComponent;
        }

        if (priceDisplayMode === "mixed") {
            return (
                <>
                    {itemPrice.amount > 0 ? "+" : ""}
                    {moneyComponent}
                </>
            )
        }
    }

    return (
        <div
            className={`product-item-option product-variant-option ${checked ? "active" : ""} ${disabled ? "disabled" : ""}`}
            aria-checked={checked} tabIndex={0} onKeyDown={handleOnKeyDown()} onClick={handleChange}>
            <input type="radio" checked={checked}
                   name="variant"
                   id={`variant-${productItemGroup.reference_id}-${item.item_id}`}
                   value={item.item_id}/>
            {checked && (
                <div className="check-circle">
                    <CheckCircleIco/>
                </div>
            )}
            <label htmlFor={`variant-${productItemGroup.reference_id}-${item.item_id}`}>
                <span className="item-name">
                    {MenuEditItemViewHelper.getParsedNameForItemGroupItem(itemInfo, productItemGroup)}
                </span>
                <span className="item-price">
                   {renderPrice()}
                </span>
            </label>
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    items: getItems(state.menu),
    modifierGroups: getModifierGroups(state.menu),
    promotions: getPromotions(state.menu),
    cart: getCart(state.cart),
    session: getSession(state.session)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(ProductVariant));